<template>
    <div id="exhibition-edit-page-container" v-if="isAuthenticated">

        <action-list :isExhibition="true" @openExhibitionInfoModal="openExhibitionInfoModal"></action-list>

        <draggable-list 
            :artworkList="dataTobeSentAPI.data"
            @update:artworkList="dataTobeSentAPI.data = $event"
            :isExhibition="true"
            @openDeleteModal="openDeleteModal" 
            @openImageInfoModal="openImageInfoModal">
        </draggable-list >

        <div id="modal-container">

            <!-- Delete / Edit artwork-->
            <work-info-modal 
                :visible="isWorkInfoModalVisible"
                :artwork="selectedArtwork"
                :isExhibition="true"
                @confirm="handleWorkInfo"
                @cancel="closeWorkInfoModal">
            </work-info-modal>

            <delete-confirmation-modal 
                :visible="isDeleteConfirmationModalVisible"
                :orderNo="artworkOrderNoToBeDeleted"
                @confirm="handleDelete" 
                @cancel="closeDeleteModal"
                :isExhibition="true">
            </delete-confirmation-modal>

            <!--Edit exhibition info-->
            <exhibitiion-info-modal 
                :visible="isExhibitionInfoModalVisible"
                :p_exhibitionInfo_EN="dataTobeSentAPI.exhibitionInfo_EN"
                :p_exhibitionInfo_TR="dataTobeSentAPI.exhibitionInfo_TR"
                :p_exhibitionName_EN="dataTobeSentAPI.exhibitionName_EN"
                :p_exhibitionName_TR="dataTobeSentAPI.exhibitionName_TR"
                @confirm="handleExhibitionInfo"
                @cancel="closeExhibitionInfoModal">
            </exhibitiion-info-modal>

        </div>
    </div>
</template>

<script>
import DraggableList from '@/components/DraggableList.vue';
import ActionList from '@/components/ActionList.vue';
import ExhibitionInfoModal from '@/components/edit-modals/ExhibitionInfoModal.vue';
import WorkInfoModal from '@/components/edit-modals/WorkInfoModal.vue';
import DeleteConfirmationModal from '@/components/edit-modals/DeleteConfirmationModal.vue';
import axios from 'axios';

export default{
    components: {
        "draggable-list": DraggableList,
        "action-list": ActionList,
        "exhibitiion-info-modal": ExhibitionInfoModal,
        "work-info-modal": WorkInfoModal,
        "delete-confirmation-modal": DeleteConfirmationModal
    },

    data(){
        return{
            isAuthenticated: false,

            old: [],

            dataTobeSentAPI: {
                count: 0,
                data: [],
                exhibitionName_EN: "",
                exhibitionName_TR: "",
                exhibitionInfo_EN: "",
                exhibitionInfo_TR: "",
            },

            isExhibitionInfoModalVisible : false,
            isWorkInfoModalVisible : false,
            isDeleteConfirmationModalVisible : false,

            selectedArtwork : [],
            artworkOrderNoToBeDeleted: 0,
        }
    },

    methods:{
        //Delete operations
        openDeleteModal(artworkOrderNo) {
            this.isDeleteConfirmationModalVisible = true;
            this.artworkOrderNoToBeDeleted = artworkOrderNo;
        },
        closeDeleteModal() {
            this.isDeleteConfirmationModalVisible = false;
        },
        handleDelete(artworkOrderNo) {
            this.dataTobeSentAPI.data = this.dataTobeSentAPI.data.filter(item => item.orderNo !== artworkOrderNo);
            this.closeDeleteModal();
            window.location.reload();
        },

        //Artwork info edit operations
        openImageInfoModal(artworkOrderNo){
            this.isWorkInfoModalVisible = true;
            this.selectedArtwork = this.dataTobeSentAPI.data.find(x => x.orderNo == artworkOrderNo);
        },
        closeWorkInfoModal(){
            this.isWorkInfoModalVisible = false;
            this.selectedArtwork = [];
        },
        handleWorkInfo(updatedArtwork){
             // artworks dizisindeki ilgili öğeyi bul ve güncelle
            const index = this.dataTobeSentAPI.data.findIndex(x => x.orderNo === updatedArtwork.orderNo);
            if (index !== -1) {
                // Vue 3'te reaktivite Proxy tabanlı olduğu için doğrudan atama yapabilirsiniz
                this.dataTobeSentAPI.data[index] = updatedArtwork;
            }
            this.closeWorkInfoModal();
            window.location.reload();
        },

        //Exhibition info edit operations
        openExhibitionInfoModal(){
            this.isExhibitionInfoModalVisible = true;
        },
        closeExhibitionInfoModal(){
            this.isExhibitionInfoModalVisible = false;
        },
        handleExhibitionInfo(updatedExhibitionInfo){
            this.dataTobeSentAPI.exhibitionName_EN = updatedExhibitionInfo.exhibitionNameEN;
            this.dataTobeSentAPI.exhibitionName_TR = updatedExhibitionInfo.exhibitionNameTR;
            this.dataTobeSentAPI.exhibitionInfo_EN = updatedExhibitionInfo.exhibitionInfoEN;
            this.dataTobeSentAPI.exhibitionInfo_TR = updatedExhibitionInfo.exhibitionInfoTR;
            this.closeExhibitionInfoModal();
        },

        //API operations
        async getExhibitionInfo(){
            try {
                // API çağrısını asenkron şekilde bekle
                const response = await axios.get("/api-path/Exhibition/get-all-images");

                // Axios, zaten JSON döndürdüğü için `response.data` yeterli
                const data = response.data;

                // Gelen veriyi değişkene map'le
                this.dataTobeSentAPI.count = data.count;
                this.dataTobeSentAPI.data = data.data;
                this.dataTobeSentAPI.exhibitionInfo_EN = data.exhibitionInfo_EN;
                this.dataTobeSentAPI.exhibitionInfo_TR = data.exhibitionInfo_TR;
                this.dataTobeSentAPI.exhibitionName_EN = data.exhibitionName_EN;
                this.dataTobeSentAPI.exhibitionName_TR = data.exhibitionName_TR;
                
            } catch (error) {
                console.error("API call failed:", error);
            }
        }
    },
    
    watch:{
        dataTobeSentAPI: {
            handler(newValue, oldValue) {
                this.dataTobeSentAPI = newValue;
                console.log(newValue);
                this.old = oldValue;
            },
            deep: true,
        },
    },

    mounted(){
        if (localStorage.getItem("confirmation") === "onaylandi") {
            this.isAuthenticated = true;
            if (!localStorage.getItem("exhibitionPageRefreshed")) {
                // Sayfa daha önce yenilenmediyse, sayfayı yenile
                localStorage.setItem("exhibitionPageRefreshed", "true");
                window.location.reload();
            }
            this.getExhibitionInfo();
        }else{
            this.isAuthenticated = false;
            this.$router.push('/site-settings');
        }    
    }
}
</script>

<style scoped>

#exhibition-edit-page-container{
    width: 80vw;
    display: flex;
    flex-direction: column;
}

</style>